export default [
  {
    key: 'any',
    value: 'Any team',
    icon: {
      name: 'users',
    },
  },
]
